<div>
    <ng-container *ngIf="!ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-radio-group
                aria-labelledby="example-radio-group-label"
                class="example-radio-group"
                [formControl]="ngControl.control">
            <mat-radio-button class="example-radio-button" *ngFor="let item of items" [value]="item.id">
                {{item.description}}
            </mat-radio-button>
        </mat-radio-group>
<!--        <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">-->
<!--            <mat-select class="multiple-selection" [formControl]="ngControl.control" [placeholder]="placeholder" multiple>-->
<!--                &lt;!&ndash; CLOSED CONTROL &ndash;&gt;-->
<!--                <mat-select-trigger>                            -->
<!--                    <div class="multiple-selection-item">-->
<!--                        <mat-chip-grid>-->
<!--                            <mat-chip *ngFor="let selectedItemId of ngControl.value" class="chip-item" color="accent" selected>-->
<!--                                {{ getItemDescription(selectedItemId) | translate }}-->
<!--                            </mat-chip>-->
<!--                        </mat-chip-grid>-->
<!--                    </div>-->
<!--                </mat-select-trigger>-->
<!--                <mat-option *ngFor="let item of _items$ | async"-->
<!--                    [value]="item.id">-->
<!--                    {{item.description | translate}}-->
<!--                </mat-option>-->
<!--            </mat-select>             -->
<!--        </mat-form-field> -->
        <!-- errors -->
        <ng-container *ngIf="ngControl.touched">
            <mat-error *ngIf="ngControl.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
        </ng-container> 
    </ng-container>

    <ng-container *ngIf="ngControl.control.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <p style="font-weight: bold;">{{items|getById:value:'description'}}</p>
    </ng-container>
</div>


<!-- <mat-select [formControlName]="evaluationFormControlName" class="multiple-selection" 
    (selectionChange)="removeMultipleSelectionNullValue()" multiple>

    <mat-select-trigger>                            
        <div *ngFor="let selectedItem of evaluationFormGroup.get(evaluationFormControlName).value" class="multiple-selection-item">                                
            <div *ngIf="selectedItem.id != null">
                <i class="material-icons md-24" style="margin-right: 0.3em;">check_box</i>
                <span>{{ selectedItem.description | trim}}</span>  
            </div>
            <div *ngIf="selectedItem.id == null">
                <i class="material-icons md-24" style="margin-right: 0.3em;">close</i>
                <span>{{ 'EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION' | translate }}</span>  
            </div>          
        </div>
    </mat-select-trigger>
    
    <mat-option *ngFor="let answer of answers" [value]="answer.id">
        {{answer.description}}
    </mat-option>
    <mat-option [value]="getNoSelectionItem()" [disabled]="!nullSelectionEnabled()">
        {{ 'EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION' | translate }}
    </mat-option>
</mat-select> -->
